import { checkPermissions } from './utils';

const recurChildValidRoutes = (route, permissions, isSuper) => {
  const children = route.children.filter((childRoute) => {
    if (childRoute.permissions) {
      if (
        isSuper ||
        checkPermissions(
          permissions,
          childRoute.permissions,
          childRoute.satisfyAll,
        )
      ) {
        return true;
      }
      return false;
    }
    return true;
  });
  if (
    !children.find((child) => child.index) &&
    children.find((child) => child.fallbackIndex)
  ) {
    let oneAndDone = false;
    children.map((child) => {
      const item = child;
      if (child.fallbackIndex && !oneAndDone) {
        oneAndDone = true;
        item.index = true;
      }
      return item;
    });
  }

  // this is where we will recursively resolve the child permissions
  return children.map((child) => {
    if (child.children) {
      const childRoutes = recurChildValidRoutes(child, permissions, isSuper);
      return { ...child, children: childRoutes };
    }
    return child;
  });
};

/**
 * Get valid auth routes based on permissions.
 * @param {object} AuthRoutes the routes to filter
 * @param {object} permissions the permissions
 * @param {boolean} isSuper if the user is a super user
 * @param {object} company the company object
 * @returns {object} the valid routes
 */
const getValidAuthRoutes = (
  AuthRoutes,
  permissions,
  isSuper = false,
  company = undefined,
) =>
  AuthRoutes.filter((route) => {
    if (route.permissions) {
      if (
        isSuper ||
        checkPermissions(permissions, route.permissions, route.satisfyAll)
      ) {
        if (company) {
          let validRoute = false;
          if (
            route.company_user_type &&
            route.company_user_type === company.company_user_type
          ) {
            validRoute = true;
          }
          if (route.type) {
            switch (route.type) {
              case 'dealer':
                if (company.is_dealer) {
                  validRoute = true;
                }
                break;
              case 'supplier':
                if (company.is_supplier) {
                  validRoute = true;
                }
                break;
              case 'both':
                if (company.is_supplier || company.is_dealer) {
                  validRoute = true;
                }
                break;
              default:
                validRoute = false;
            }
            return validRoute;
          }
          return validRoute;
        }
        return true;
      }
      return false;
    }
    return true;
  }).map((route) => {
    if (route.children) {
      const children = recurChildValidRoutes(route, permissions, isSuper);
      return { ...route, children };
    }
    return route;
  });

export default getValidAuthRoutes;
